import { BlockDocument } from '../Blocks/queryBuilder';
import { DepartmentDocument } from '../Department/queryBuilder';
import { EquipmentStatusDocument } from '../EquipmentStatus/queryBuilder';
import { EquipmentTypeDocument } from '../EquipmentType/queryBuilder';
import { PanelDocument } from '../Panels/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { RoomDocument } from '../Rooms/queryBuilder';
import { SiteDocument } from '../Site/queryBuilder';
import { SurveyPointDocument } from '../SurveyPoints/queryBuilder';
import {
  EquipmentDocument,
  equipmentPullQueryBuilder,
  equipmentPushQueryBuilder,
  equipmentPushResponseModifier,
} from './queryBuilder';

export function equipmentFamilyMember(
  configBuilder: ConfigBuilder,
  blocks: FamilyMember<BlockDocument>,
  department: FamilyMember<DepartmentDocument>,
  equipmentStatus: FamilyMember<EquipmentStatusDocument>,
  equipmentType: FamilyMember<EquipmentTypeDocument>,
  panels: FamilyMember<PanelDocument>,
  rooms: FamilyMember<RoomDocument>,
  sites: FamilyMember<SiteDocument>,
  surveyPoints: FamilyMember<SurveyPointDocument>,
): FamilyMember<EquipmentDocument> {
  const syncConfig = configBuilder<EquipmentDocument>(RxdbCollectionNameV2.EQUIPMENT);
  doNotAutoSync(syncConfig);

  pull(syncConfig, equipmentPullQueryBuilder);

  const pushConfig = push(syncConfig, equipmentPushQueryBuilder);
  pushConfig.responseModifier = equipmentPushResponseModifier;

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.EQUIPMENT, replicationState, [
    blocks,
    department,
    equipmentStatus,
    equipmentType,
    panels,
    rooms,
    sites,
    surveyPoints,
  ]);
}
